"use client";
import { useEffect } from "react";
import Banner from "@/components/Banner";

interface MainBanner {
  id: number;
  imageUrl: string;
  imageName: string;
  hyperlink: string;
}

interface HomeBannerProps {
  webBanners: MainBanner[];
  mobileBanners: MainBanner[];
}

const HomeBanner = ({ webBanners, mobileBanners }: HomeBannerProps) => {
  // 모바일 배너가 없으면 홈 맨 위가 흰 배경이라, 흰색 메뉴 막대(RightMenuBar)가 보이지 않는다. 메뉴 쪽에 알려 막대 색을 바꾸게 한다.
  const noMobileBanner = mobileBanners.length === 0;
  useEffect(() => {
    document.body.dataset.noMobileBanner = String(noMobileBanner);
    window.dispatchEvent(new Event("home-banner-change"));
    return () => {
      delete document.body.dataset.noMobileBanner;
      window.dispatchEvent(new Event("home-banner-change"));
    };
  }, [noMobileBanner]);

  // 배너 목록은 서버에서 이미 다 불러온 뒤에 여기로 온다(불러오는 동안은 page.tsx의 Suspense 대체 화면이 보인다).
  // 그런데 Banner는 목록이 비면 '불러오는 중' 스피너를 보여 줘서, 조회 실패나 등록된 배너가 없을 때 스피너가 끝없이 돌았다.
  // 그래서 목록이 비었으면 배너 영역 자체를 그리지 않는다. (Banner는 숙소 페이지 등에서도 쓰므로 Banner 자체는 바꾸지 않는다)
  return (
    <>
      {webBanners.length > 0 && (
        <div className="mobile:hidden">
          <Banner data={webBanners} enableAutoplay={true} autoplayDelay={4000} priority={true} />
        </div>
      )}
      {mobileBanners.length > 0 && (
        <div className="hidden mobile:block">
          <Banner data={mobileBanners} enableAutoplay={true} autoplayDelay={4000} priority={true} />
        </div>
      )}
    </>
  );
};

export default HomeBanner;
